import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface AdminRouteProps {
  children: React.ReactElement;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    // Show loading indicator while checking auth
    return (
        <div className="flex justify-center items-center h-screen">
            <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary"></div>
        </div>
    );
  }

  if (!user || !user.isAdmin) {
    // Redirect them to the /collections page if they are not logged in or not an admin
    // state={{ from: location }} prevents losing the intended destination after login
    console.warn('Admin route blocked: User not authenticated or not admin.', user);
    return <Navigate to="/collections" state={{ from: location }} replace />;
  }

  return children;
};

export default AdminRoute; 